module.exports = __webpack_public_path__ + "static/media/b9.39951683.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/butterfly/b9.jpg
// module id = 455
// module chunks = 0